import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useAuthStore from 'store/auth';
import SymptomWrapper from './components/SymptomWrapper';
import { useSymptomStore } from 'store/symptom';
import { useGetSymptomQuestion } from 'services/symptom-checker/hooks';
import Loader from 'components/Loader';
import { SYMPTOM_CODE } from 'lib/symptom-checker';
import SymptomBodyPart from './BodyPart';
import SymptomOtherBodyPart from './OtherBodyPart';
import SymptomFeelSymptoms from './FeelSymptoms';
import SymptomPainLevel from './PainLevel';
import SymptomDuration from './SymptomDuration';
import SymptomStartedMedication from './StartedMedication';
import SymptomFileUpload from './FileUpload';
import SymptomAdditionalDetails from './AdditionalDetails';
import SymptomOtherSymptom from './OtherSymptom';
import SymptomCheckerConfirmation from './Confirmation';
// import SymptomReview from './Review';

export default function GenerateSymptomCheckerPage() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const profileId = useAuthStore((store) => store.currentUserProfileId);
  const questionData = useSymptomStore((store) => store.questionData);
  const setQuestionData = useSymptomStore((store) => store.setQuestionData);
  const { data, isLoading } = useGetSymptomQuestion({
    payload: { type: 'latest', profileId },
    enabled: !code && !questionData,
  });

  const question = data?.data;
  console.log('🚀 ~ GenerateSymptomCheckerPage ~ questionData:', questionData);
  console.log('🚀 ~ GenerateSymptomCheckerPage ~ questionData:', data);

  useEffect(() => {
    if (!question || questionData) return;

    setQuestionData(data);
  }, [question]);

  useEffect(() => {
    return () => {
      setQuestionData(undefined);
    };
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!questionData || !questionData?.data?.code) {
    return null;
  }

  // if (questionData?.screen === 'review') {
  //   return <SymptomReview />;
  // }

  if (questionData?.screen === 'pop-up') {
    return <SymptomCheckerConfirmation />;
  }

  const renderQuestion = () => {
    switch (questionData?.data.code) {
      case SYMPTOM_CODE.SELECT_BODY_PART:
        return <SymptomBodyPart />;
      case SYMPTOM_CODE.OTHER_BODY_PART:
        return <SymptomOtherBodyPart />;
      case SYMPTOM_CODE.FEEL_SYMPTOMS:
        return <SymptomFeelSymptoms />;
      case SYMPTOM_CODE.PAIN_LEVEL:
        return <SymptomPainLevel />;
      case SYMPTOM_CODE.SYMPTOMS_DURATION:
        return <SymptomDuration />;
      case SYMPTOM_CODE.STARTED_MEDICATION:
        return <SymptomStartedMedication />;
      case SYMPTOM_CODE.IMAGE_UPLOAD:
        return <SymptomFileUpload />;
      case SYMPTOM_CODE.ADDITIONAL_DETAIL:
        return <SymptomAdditionalDetails />;
      case SYMPTOM_CODE.OTHER_SYMPTOMS:
        return <SymptomOtherSymptom />;
      default:
        return null;
    }
  };

  return <SymptomWrapper>{renderQuestion()}</SymptomWrapper>;
}
